export const SET_LEGAL_PEOPLE = "LEGAL_PEOPLE/SET_LEGAL_PEOPLE";
export const SET_LEGAL_PERSON = "LEGAL_PEOPLE/SET_LEGAL_PERSON";
export const SET_PAGINATION = "LEGAL_PEOPLE/SET_PAGINATION";
